import { render, staticRenderFns } from "./account-alt.vue?vue&type=template&id=cf5ac6fe&scoped=true&"
import script from "./account-alt.vue?vue&type=script&lang=js&"
export * from "./account-alt.vue?vue&type=script&lang=js&"
import style0 from "./account-alt.vue?vue&type=style&index=0&id=cf5ac6fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ac6fe",
  null
  
)

export default component.exports